import script from "./CouleursSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./CouleursSelector.vue?vue&type=script&setup=true&lang=ts"

import "./CouleursSelector.vue?vue&type=style&index=0&id=20f3f646&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20f3f646"]])

export default __exports__